<template>
    <div id="navigation" style="background: url(../static/img/bg.png);background-size: 100% 100%;height: 720px;margin-top: -100px;">
        <div class="header1">
            <p class="p1">
                <!--<img src="./images/guohui.png" alt="">-->
            </p>
            <p class="p2"></p>
            <p class="p3">物流大数据展示系统</p>
        </div>
        <div class="contain">
            <ul>
                <li>
                    <a href="bigdata.html" target="_blank">
                        <img src="../../static/img/jinrong.png" alt="">
                        <span>数据集成平台</span>
                    </a>
                </li>
                <li>
                    <a href="survey.html" target="_blank">
                        <img src="../../static/img/xinyong.png" alt="">
                        <span>数据共享平台</span>
                    </a>
                </li>
                <li>
                    <a href="index2.html" target="_blank">
                        <img src="../../static/img/fengxian.png" alt="">
                        <span>数据治理平台</span>
                    </a>
                </li>
                <li>
                    <a href="index3.html" target="_blank">
                        <img src="../../static/img/chanye.png" alt="">
                        <span>用户中心</span>
                    </a>
                </li>
            </ul>
        </div>

    </div>


</template>


<script>
    //import homePage from './components/homePage.vue';

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {

            }
        },
        created() {
            window.onload = function () {
                //屏蔽键盘事件
                document.onkeydown = function () {
                    var e = window.event || arguments[0];
                    /*延迟，兼容FF浏览器  */
                    if (e.keyCode == 83 && e.ctrlKey) {
                        setTimeout(function () {
                            alert('整理不易，不要另存哦');
                        }, 1);
                        return false;
                    } else if (e.keyCode == 123) {
                        //F12
                        setTimeout(function () {
                            alert('亲，你想干嘛,不要做坏事哦');
                        }, 1);
                        return false;
                        //Ctrl+Shift+I
                    } else if ((e.ctrlKey) && (e.shiftKey) && (e.keyCode == 73)) {
                        setTimeout(function () {
                            alert('亲，你想干嘛,不要做坏事哦');
                        }, 1);
                        return false;
                        //Shift+F10
                    } else if ((e.shiftKey) && (e.keyCode == 121)) {
                        setTimeout(function () {
                            alert('亲，你想干嘛,不要做坏事哦');
                        }, 1);
                        return false;
                        //Ctrl+U
                    } else if ((e.ctrlKey) && (e.keyCode == 85)) {
                        setTimeout(function () {
                            alert('亲，你想干嘛,不要做坏事哦');
                        }, 1);
                        return false;
                    }
                };
                //屏蔽鼠标右键

            }
        },
        mounted() {
        },
        methods: {

        }

    }
</script>


<style scoped>

.contain ul li:hover{
    background: url('../../static/img/chooseKuang.png') center center no-repeat;
}
   .contain ul li span {
    display: inline-block;
    vertical-align: 16px;
    font-size: 30px;
    color: #57daff;
    margin-left: 20px;
}

    div {
        display: block;
    }

    .header1 {
        width: 700px;
        margin: 0 auto;
    }

    .header1 p.p1 {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        margin-top: 110px;
    }

    .header1 p.p2 {
        height: 40px;
        margin: 0 auto;
        text-align: center;
        line-height: 40px;
        margin-top: 10px;
        font-size: 20px;
        color: #fec468;
    }

    .header1 p.p3 {
        height: 40px;
        margin: 0 auto;
        text-align: center;
        line-height: 40px;
        font-size: 28px;
        color: #bddde6;
    }

    .contain {
        width: 1210px;
        margin: 0 auto;
        margin-top: 80px;
        height: 400px;
    }

    .contain ul {
        width: 100%;
        height: 100%;
    }

    .contain ul li {
        width: 600px;
        height: 200px;
        line-height: 210px;
        float: left;
        background-image: url(../../static/img/kuang.png);
        background-position: center center;
        background-repeat: no-repeat;
        margin-bottom: 50px;
        background-color: transparent;
    }

    .contain ul li a {
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/bigHomePage.vue